import { Box, Button, Stack, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { type FC } from "react";
import { COOPERATION_LEVEL_BANDS } from "./cooperation-level";

type Props = {
  value: number | "";
  onChange: (next: number | "") => void;
};

export const CooperationLevelPicker: FC<Props> = ({ value, onChange }) => {
  return (
    <Stack gap={1.5}>
      {COOPERATION_LEVEL_BANDS.map((row) => (
        <Stack key={row.band} direction="row" alignItems="center" gap={1.5}>
          <Box
            sx={{
              width: 36,
              height: 36,
              borderRadius: 1.5,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              flexShrink: 0,
            }}
          >
            <Typography sx={{ fontWeight: 800, color: "primary.main", fontSize: 15 }}>
              {row.band}
            </Typography>
          </Box>
          <Stack direction="row" gap={1} flex={1}>
            {row.values.map((level) => {
              const selected = value === level;
              return (
                <Button
                  key={level}
                  variant={selected ? "contained" : "outlined"}
                  color={selected ? "primary" : "inherit"}
                  onClick={() => onChange(selected ? "" : level)}
                  aria-pressed={selected}
                  aria-label={`דירוג ${row.band}${level}`}
                  sx={{
                    flex: 1,
                    minWidth: 0,
                    minHeight: 48,
                    borderRadius: 2,
                    fontWeight: 700,
                    fontSize: "1rem",
                    borderColor: selected ? "primary.main" : "divider",
                    color: selected ? "primary.contrastText" : "text.primary",
                    textTransform: "none",
                  }}
                >
                  {level}
                </Button>
              );
            })}
          </Stack>
        </Stack>
      ))}
    </Stack>
  );
};
